var _g, _rect, _rect2, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLuckyMintBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 192,
    height: 71,
    viewBox: "0 0 192 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_iiii_3398_3536)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 71,
    rx: 10,
    fill: "white",
    fillOpacity: 0.3
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 9,
    width: 175,
    height: 53,
    rx: 8,
    fill: "url(#paint0_linear_3398_3536)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 15,
    width: 158,
    height: 41,
    rx: 6,
    fill: "url(#paint1_linear_3398_3536)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_3398_3536)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.873 39.3047H43.5312V28.6699H40.2988V42H48.873V39.3047ZM55.6797 39.5488C54.2734 39.5488 53.3066 38.6992 53.3066 37V28.6699H50.084V37.4492C50.084 40.3301 52.2031 42.2441 55.6797 42.2441C59.1562 42.2441 61.2754 40.3301 61.2754 37.4492V28.6699H58.043V37C58.043 38.6797 57.0762 39.5488 55.6797 39.5488ZM66.4609 34.6465C66.4609 32.3516 67.3789 31.1016 68.9902 31.1016C70.4453 31.1016 71.3145 32.1562 71.3242 33.6113H74.4102V33.2305C74.4102 30.3496 72.1348 28.4355 68.9609 28.4355C65.25 28.4355 63.1699 30.8281 63.1699 34.6465V36.0527C63.1699 39.8516 65.25 42.2441 68.9609 42.2441C72.125 42.2441 74.4102 40.3496 74.4102 37.5273V37.1367H71.3242C71.3145 38.543 70.4453 39.5781 68.9902 39.5781C67.3789 39.5781 66.4609 38.3379 66.4609 36.0723V34.6465ZM87.8086 28.6699H84.3613L79.7812 34.334H79.6445V28.6699H76.4121V42H79.6445V37.9766L80.8262 36.5801L84.1758 42H87.9844L83.1895 34.4512L87.8086 28.6699ZM95.6504 42V37.2734L100.113 28.6699H96.6855L94.1465 34.1582H94.0293L91.5 28.6699H87.9648L92.4277 37.3613V42H95.6504ZM107.926 42V33.748H108.072L110.895 39.9883H112.789L115.602 33.748H115.738V42H118.639V28.6699H115.338L111.91 36.1992H111.812L108.395 28.6699H105.055V42H107.926ZM124.488 42V28.6699H121.256V42H124.488ZM130.055 42V34.0312H130.172L135.543 42H138.082V28.6699H135.094V36.5605H134.986L129.625 28.6699H127.076V42H130.055ZM146.354 42V31.3066H149.986V28.6699H139.508V31.3066H143.131V42H146.354Z",
    fill: "#623B00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_iiii_3398_3536",
    x: -1,
    y: -1,
    width: 194,
    height: 73,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.776471 0 0 0 0 0.717647 0 0 0 0 0.85098 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_3398_3536"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.8 0 0 0 0 0.8 0 0 0 0 0.8 0 0 0 0.9 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_3398_3536",
    result: "effect2_innerShadow_3398_3536"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.776471 0 0 0 0 0.717647 0 0 0 0 0.85098 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_3398_3536",
    result: "effect3_innerShadow_3398_3536"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.776471 0 0 0 0 0.717647 0 0 0 0 0.85098 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_innerShadow_3398_3536",
    result: "effect4_innerShadow_3398_3536"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_3398_3536",
    x: 40.2988,
    y: 28.4355,
    width: 110.688,
    height: 14.8086,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_3398_3536"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3398_3536",
    x1: 95.5,
    y1: 9,
    x2: 95.5,
    y2: 62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAD31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#FFDC25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BB8213"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3398_3536",
    x1: 55.2526,
    y1: 19.1,
    x2: 62.1926,
    y2: 64.3378,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEC45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FECE1E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLuckyMintBtn);
export default __webpack_public_path__ + "static/media/luckyMintBtn.a4d52c6b22b98fde001bc318312ed7c1.svg";
export { ForwardRef as ReactComponent };